import { ComponentWithAs } from '@chakra-ui/react';
import { IIconProps, Icon } from '~/components/Icon/Icon';

export const NewCommentsIcon: ComponentWithAs<'svg', IIconProps> = (
  props: any,
) => (
  <Icon
    data-testid="new-comments-icon"
    boxSize={6}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.1123 9.80968C0.319401 5.6028 3.55694 1 8.30889 1H8.56526C12.1191 1 15 3.75403 15 7.15128C15 10.9337 11.7924 14 7.83568 14H1.59823C1.34439 14 1.11819 13.8468 1.03394 13.6179C0.949693 13.389 1.02574 13.1342 1.22366 12.9823L2.79612 11.7751C2.86488 11.7223 2.8892 11.6326 2.85593 11.5546L2.1123 9.80968ZM8.30889 2.1437C4.40661 2.1437 1.74795 5.92349 3.22027 9.37817L3.9639 11.123C4.1968 11.6695 4.02655 12.2973 3.54526 12.6668L3.29845 12.8563H7.83568C11.1317 12.8563 13.8036 10.3021 13.8036 7.15128C13.8036 4.38567 11.4583 2.1437 8.56526 2.1437H8.30889Z"
      fill="currentColor"
    />
  </Icon>
);
